export default "__VITE_ASSET__DNwUX8Hi__"